// Lightweight event utility for hunt-related global events.
// Uses window CustomEvent under the hood; guards for non-browser/test envs.

export const HUNT_EVENTS = {
  COMPLETED: 'hunt:completed'
};

const PENDING_KEY = 'hunt.completed.pending';

function setPending(detail) {
  try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(detail || {})); } catch (_) {}
}

export function consumePendingHuntCompleted() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PENDING_KEY);
    try { return JSON.parse(raw); } catch (_) { return null; }
  } catch (_) { return null; }
}

/**
 * Emit a hunt completed event after auto sign-in.
 * detail: { locationId, date, timePeriod, userId, clubId? }
 */
export function emitHuntCompleted(detail) {
  try {
    // Persist so pages can react even if not mounted at emit time
    setPending(detail);
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      const evt = new CustomEvent(HUNT_EVENTS.COMPLETED, { detail: detail || {} });
      window.dispatchEvent(evt);
    }
  } catch (_) {
    // no-op in non-browser or older environments
  }
}

/**
 * Subscribe to hunt completed events. Returns an unsubscribe function.
 * handler receives the event.detail object.
 */
export function onHuntCompleted(handler) {
  if (typeof handler !== 'function') return () => {};
  const wrapped = (evt) => {
    try { handler(evt?.detail || {}); } catch (_) {}
  };
  try {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener(HUNT_EVENTS.COMPLETED, wrapped);
      return () => {
        try { window.removeEventListener(HUNT_EVENTS.COMPLETED, wrapped); } catch (_) {}
      };
    }
  } catch (_) {
    // ignore
  }
  return () => {};
}


